module.exports = __webpack_public_path__ + "img/public/SiteIcons/languageChangeIcon.svg?21009771";